import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';

const API_URL = localStorage['URL_API'] == undefined ? "http://local.sgi.natura.api": localStorage['URL_API'] ;
const API_TOKEN = localStorage['URL_AUTH'] == undefined? "http://local.sgi.natura.auth": localStorage['URL_AUTH'];

const GRANT_TYPE = 'password';
const USERNAME = 'public';
const PASSWORD = '';
const CLIENT_ID = 'ReseteoDeContrasena';
const CLIENT_SECRET = '86F310C7-BBFB-4790-93C0-055B15EDB289';

@Injectable({
  providedIn: 'root'
})

export class AppHttpService {

  constructor(private http: HttpClient, private router:Router) {

    console.log('AuthService instantiated in environment ' + environment.production);

  }

  private getHeader() {
    let token = 'bearer ' + localStorage['token'];
    let header = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return header;
  }

  autenticar() {
    let header = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    let grant_type = GRANT_TYPE;
    let username = USERNAME;
    let password = PASSWORD;
    let client_id = CLIENT_ID;
    let client_secret = CLIENT_SECRET;
    let body = `client_id=${client_id}&client_secret=${client_secret}&grant_type=${grant_type}&username=${username}&password=${password}`;

    return this.http.post(`${API_TOKEN}/api/token`, body, header).subscribe((res: any) => {
      console.log("token gerado");
      localStorage['token'] = res.access_token;
    }, ((error: any) => {
      console.log(error);
    }));
  }


  getEmailpass(id: String, document: String, date: String): Observable<any> {
    return this.http.get(`${API_URL}/api/Public/${id}/EmailPhoneInfo?document=${document}&birthDate=${date}`, this.getHeader())
      .pipe(
        catchError(this.handleError))
  }

  postNewPass(id: String, code: String, pass: String): Observable<any> {
    const encodedPassword = encodeURIComponent(pass.toString());

    let body = JSON.stringify({
      VerificationCode: code,
      NewPassword: encodedPassword
    });
    return this.http.post(`${API_URL}/api/Public/${id}/DefinePassword?VerificationCode=${code}&NewPassword=${encodedPassword}&synchonizePassword=true`, body, this.getHeader())
      .pipe(
        catchError(this.handleError))
  } 

  postSendVerificationCode(id: String, verificationCodeOption: number): Observable<any> {
    let body = JSON.stringify({
      verificationCodeOption: verificationCodeOption
    });
    return this.http.post(`${API_URL}/api/Public/${id}/SendValidationCode?verificationCodeOption=${verificationCodeOption}`, body, this.getHeader())
      .pipe(
        catchError(this.handleError))
  }

  getVerificationCodeValidation(id: String, verificationCode: String): Observable<any> {
    return this.http.get(`${API_URL}/api/Public/${id}/VerificationCodeValidation?verificationCode=${verificationCode}`, this.getHeader())
      .pipe(
        catchError(this.handleError))
  }
  
  getValidatePasswordToken(passwordToken: String): Observable<any> {
    return this.http.get(`${API_URL}/api/Public/ValidatePasswordToken?passwordToken=${passwordToken}`, this.getHeader())
      .pipe(
        catchError(this.handleError))
  }

  AccesRule(id: number): Observable<any> {
    return this.http.get(`${API_URL}/api/Public/${id}/AccesRule`, this.getHeader())
      .pipe(
        catchError(this.handleError))
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }
}